<template>
  <div class="page">
    <div class="img">
      <img src="~@/assets/img/new-img.jpg"/>
    </div>
    <div class="page-list">
      <div class="page-list-title">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="page-tabs">
          <el-tab-pane label="客运业务" name="1"></el-tab-pane>
          <el-tab-pane label="公交业务" name="2"></el-tab-pane>
          <el-tab-pane label="货运业务" name="3"></el-tab-pane>
          <el-tab-pane label="旅游业务" name="4"></el-tab-pane>
          <el-tab-pane label="维修业务" name="5"></el-tab-pane>
        </el-tabs>
      </div>

      <div style="background-color: #f2f7fb;padding: 10px;">
          <div>
            <div   v-html="instructions.articleContent"  style="width: 1200px;display: flex; justify-content: center;flex-direction: column;text-align: left;"></div>
          </div>
      </div>

      <!--<div class="industrial-info">-->
        <!--<div><img src="~@/assets/img/new-img.jpg" style="height: 220px;width: 460px;margin: 10px" /></div>-->
        <!--<div>-->
          <!--<div>客运业务</div>-->
          <!--<div>客运业务客运业务客运业务客运业务</div>-->
        <!--</div>-->
      <!--</div>-->

      <div class="new-list-details" v-loading="state">
        <div v-for="(item,index) in data" @click="open(item)">
          <div style="width: 355px;height: 179px">
            <img :src="item.coverImage" style="width: 100%;height: 100%"/>
          </div>
          <div class="new-list-details-date">
            <div style="font-size: 20px">{{item.createTime}}</div>
          </div>
          <div class="new-list-details-content">
            <div>{{item.articleTitle}}</div>
            <div>{{item.articleContent.length > 120 ? item.articleContent.replace(/nbsp;/g,'').replace(/&/g,"").replace(/<[^>]+>/g,"").substring(0,119) : item.articleContent.replace(/nbsp;/g,'').replace(/&/g,"").replace(/<[^>]+>/g,"") }}</div>          </div>
        </div>

      </div>
      <div></div>
     <div class="new-list-page">
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        :total="totalPage"
        layout="total,  prev, pager, next, jumper">
      </el-pagination>
    </div>

      <div></div>
    </div>
  </div>
</template>

<style scoped>
.industrial-info{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 80%;
  padding: 30px;
  background-color: #f2f7fb;
  height: 200px;
}

.industrial-info > div{
  margin: 10px;
  flex: 1;
}

.industrial-info > div:nth-child(2){
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.industrial-info > div:nth-child(2)> div:nth-child(1){
  font-size: 23px;
   height: 20%;
  width: 100%;
}
.industrial-info > div:nth-child(2)> div:nth-child(2){
  text-align: start;
  height: 80%;
  width: 100%;
 }

</style>

<script>
  export default {
    name: "new",
    data () {
      return {
        activeName: '1',
        pageIndex: 1,
        pageSize: 5,
        totalPage: 0,
        data:'',
        title:'',
        instructions:{
          articleContent: ''
        },
         state : false,
        classType : ''
      }
    },
    mounted: function () {
      this.activeName = this.$route.query.id+''
      this.getDataList(this.activeName)
    },
    watch: {
      '$route.query.id' (newValue, oldValue) {
        this.activeName = this.$route.query.id+''
        this.getDataList()
      },
      deep: false
    },
    methods: {
      open(obj){
        this.$router.push({path: '/new-details', query: {id: (obj.id), title: this.title,classType : this.classType}})
      },
      handleClick(){
        this.pageIndex = 1
        this.pageSize =  5
        this.getDataList(this.activeName)
      },
      getDataList(infoType){
        this.state  = true
        this.$http({
          url: this.$http.adornUrl('/website/getIndustry'),
          method: 'post',
          data: this.$http.adornData({
            "belongCity":16,
            "infoType":infoType,
            "pageSize":this.pageSize,
            "page":this.pageIndex
          })
        }).then(({data}) => {
          this.state  = false
          if (data && data.code === 0) {
            this.data = data.data.list
            this.instructions = data.data.instructions
            this.classType =  data.data.classType
          } else {
            this.$message.error("服务器无响应!")
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/modules/industrial.vue